module.exports = __webpack_public_path__ + "static/g4-157ed11b678af220010dbede7918c0b5.jpg";